import script from "./ManageCollections.vue?vue&type=script&setup=true&lang=js"
export * from "./ManageCollections.vue?vue&type=script&setup=true&lang=js"

import "./ManageCollections.vue?vue&type=style&index=0&id=4297d37e&lang=css"

const __exports__ = script;

export default __exports__